import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { QuestionObj } from 'src/types/quiz';
import quizStore from '../store/QuizStore';
import { quickToast } from '../utils/toast';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';
import { Label } from './ui/label';
import { Textarea } from './ui/textarea';

interface QuestionFormDialogProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const QuestionFormDialog: React.FC<QuestionFormDialogProps> = ({
  open,
  setOpen,
}) => {
  const [question, setQuestion] = useState<string>('');
  const [answer, setAnswer] = useState<string>('');

  const addQuestion = (): QuestionObj => {
    const questionObj = quizStore.addQuestionToScratchpad(question, answer);
    setQuestion('');
    setAnswer('');
    return questionObj;
  };

  const handleAddApprovedQuestion = (): void => {
    const questionObj = addQuestion();
    quizStore.approveQuestion(questionObj.id);
    quickToast("Added to approved questions, you're good to go!");
    setOpen(false);
  };

  const handleAddToQuiz = (): void => {
    const questionObj = addQuestion();
    quizStore.addQuestionToQuiz(questionObj.id);
    quickToast("Added to quiz questions, you're good to go!");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add New Question</DialogTitle>
          <DialogDescription>
            Enter the question and answer below. Click save when you're done.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-6 py-4">
          <div className="grid gap-2">
            <Label htmlFor="question">Question</Label>
            <Textarea
              id="question"
              value={question}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setQuestion(e.target.value)
              }
              className="min-h-[100px] resize-vertical"
              placeholder="Enter your question here..."
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="answer">Answer</Label>
            <Textarea
              id="answer"
              value={answer}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                setAnswer(e.target.value)
              }
              className="min-h-[100px] resize-vertical"
              placeholder="Enter the answer here..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={handleAddApprovedQuestion}>
            Add to Approved
          </Button>
          <Button onClick={handleAddToQuiz}>Add to Quiz</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default observer(QuestionFormDialog);

export const openQuestionFormDialog = (
  setOpen: React.Dispatch<React.SetStateAction<boolean>>,
): void => {
  setOpen(true);
};
